import config from '../tailwind.config';

export const color = config.theme.extend.colors;
